import productDetailsBR from './productDetails.br';
import productDetailsMX from './productDetails.mx';
import productDetailsCL from './productDetails.cl';
import productDetailsCO from './productDetails.co';


const productDetails = {
  BR: productDetailsBR,
  MX: productDetailsMX,
  CL: productDetailsCL,
  CO: productDetailsCO,
};

export default productDetails;
